@if (shouldRender()) {
<section
  #root
  class="hero"
  aria-label="Destacados del home"
  (mouseenter)="pause()"
  (mouseleave)="resume()"
  (focusin)="pause()"
  (focusout)="onFocusOut($event)"
>
  <div class="hero__inner">
    @if (loading()) {
      <div class="hero__stage hero__stage--skeleton" data-testid="hero-skeleton">
        <div class="hero__skeleton hero__skeleton--copy">
          <span class="hero__skeleton-line hero__skeleton-line--eyebrow"></span>
          <span class="hero__skeleton-line hero__skeleton-line--headline"></span>
          <span class="hero__skeleton-line hero__skeleton-line--headline hero__skeleton-line--headline-short"></span>
          <span class="hero__skeleton-line hero__skeleton-line--body"></span>
          <span class="hero__skeleton-line hero__skeleton-line--body hero__skeleton-line--body-short"></span>
          <div class="hero__skeleton-actions">
            <span class="hero__skeleton-line hero__skeleton-line--action"></span>
            <span class="hero__skeleton-line hero__skeleton-line--action hero__skeleton-line--action-secondary"></span>
          </div>
        </div>

        <div class="hero__skeleton hero__skeleton--media">
          <span class="hero__skeleton-tile hero__skeleton-tile--feature"></span>
          <span class="hero__skeleton-tile hero__skeleton-tile--secondary"></span>
          <span class="hero__skeleton-tile hero__skeleton-tile--tertiary"></span>
          <span class="hero__skeleton-tile hero__skeleton-tile--quaternary"></span>
          <span class="hero__skeleton-tile hero__skeleton-tile--quinary"></span>
        </div>
      </div>
    } @else {
      <div
        class="hero__stage"
        role="region"
        aria-roledescription="carousel"
        aria-label="Carousel principal del home"
      >
        @for (slide of slides(); track trackSlide($index, slide); let slideIndex = $index) {
          <article
            class="hero__slide"
            [class.hero__slide--active]="isSlideActive($index)"
            [class.hero__slide--background]="slide.type === 'background'"
            [class.hero__slide--tiles]="slide.type === 'tiles'"
            [class.hero__slide--media-right]="slide.type === 'media-right'"
            [class.hero__slide--angled]="slide.type === 'angled-media'"
            [attr.aria-hidden]="!isSlideActive($index)"
            [attr.inert]="!isSlideActive($index) ? '' : null"
          >
            @switch (slide.type) {
              @case ('tiles') {
                <div class="hero__layout hero__layout--split">
                  <div class="hero__content">
                    @if (slide.eyebrow) {
                      <p class="hero__eyebrow">{{ slide.eyebrow }}</p>
                    }

                    <h1 class="hero__headline">{{ slide.headline }}</h1>
                    <p class="hero__subheadline">{{ slide.subheadline }}</p>

                    <div class="hero__actions">
                      <a
                        class="hero__action hero__action--primary"
                        [href]="actionHref(slide.primaryAction.route, slide.primaryAction.queryParams)"
                        (click)="onActionClick($event, slide.primaryAction.route, slide.primaryAction.queryParams)"
                      >
                        {{ slide.primaryAction.label }}
                      </a>

                      @if (slide.secondaryAction; as secondaryAction) {
                        <a
                          class="hero__action hero__action--secondary"
                          [href]="actionHref(secondaryAction.route, secondaryAction.queryParams)"
                          (click)="onActionClick($event, secondaryAction.route, secondaryAction.queryParams)"
                        >
                          {{ secondaryAction.label }}
                        </a>
                      }
                    </div>
                  </div>

                  <div class="hero__media hero__media--tiles">
                    <div class="hero__tiles-grid">
                      @for (tile of getTilesSlide(slide).tiles; track tile.id; let tileIndex = $index) {
                        <a
                          class="hero__tile"
                          [class.hero__tile--feature]="tileIndex === 0"
                          [class.hero__tile--secondary]="tileIndex === 1"
                          [class.hero__tile--tertiary]="tileIndex === 2"
                          [class.hero__tile--quaternary]="tileIndex === 3"
                          [class.hero__tile--quinary]="tileIndex === 4"
                          [href]="actionHref(tile.route, tile.queryParams)"
                          (click)="onActionClick($event, tile.route, tile.queryParams)"
                        >
                          <img
                            [ngSrc]="tile.image.imageUrl"
                            [alt]="tile.image.alt"
                            [width]="tile.image.width"
                            [height]="tile.image.height"
                            [priority]="shouldPrioritizeTile(slideIndex, tileIndex)"
                            [attr.loading]="shouldPrioritizeTile(slideIndex, tileIndex) ? 'eager' : 'lazy'"
                            class="hero__tile-image"
                          />
                          <span class="hero__tile-overlay"></span>
                          <span class="hero__tile-copy">
                            <span class="hero__tile-title">{{ tile.title }}</span>
                            @if (tile.subtitle) {
                              <span class="hero__tile-subtitle">{{ tile.subtitle }}</span>
                            }
                          </span>
                        </a>
                      }
                    </div>
                  </div>
                </div>
              }

              @case ('media-right') {
                <div class="hero__layout hero__layout--split">
                  <div class="hero__content">
                    @if (slide.eyebrow) {
                      <p class="hero__eyebrow">{{ slide.eyebrow }}</p>
                    }

                    <h2 class="hero__headline">{{ slide.headline }}</h2>
                    <p class="hero__subheadline">{{ slide.subheadline }}</p>

                    <div class="hero__actions">
                      <a
                        class="hero__action hero__action--primary"
                        [href]="actionHref(slide.primaryAction.route, slide.primaryAction.queryParams)"
                        (click)="onActionClick($event, slide.primaryAction.route, slide.primaryAction.queryParams)"
                      >
                        {{ slide.primaryAction.label }}
                      </a>

                      @if (slide.secondaryAction; as secondaryAction) {
                        <a
                          class="hero__action hero__action--secondary"
                          [href]="actionHref(secondaryAction.route, secondaryAction.queryParams)"
                          (click)="onActionClick($event, secondaryAction.route, secondaryAction.queryParams)"
                        >
                          {{ secondaryAction.label }}
                        </a>
                      }
                    </div>
                  </div>

                  <div class="hero__media hero__media--product">
                    <img
                      [ngSrc]="getMediaRightSlide(slide).media.imageUrl"
                      [alt]="getMediaRightSlide(slide).media.alt"
                      [width]="getMediaRightSlide(slide).media.width"
                      [height]="getMediaRightSlide(slide).media.height"
                      [priority]="shouldPrioritizeSlide(slideIndex)"
                      [attr.loading]="shouldPrioritizeSlide(slideIndex) ? 'eager' : 'lazy'"
                      class="hero__media-image hero__media-image--product"
                    />
                  </div>
                </div>
              }

              @case ('angled-media') {
                @if (getAngledMediaSlide(slide); as angledSlide) {
                  <div
                    class="hero__angled"
                    [style.--hero-media-focus-desktop]="
                      getImageFocalPoint(angledSlide.media, 'desktop')
                    "
                    [style.--hero-media-focus-mobile]="
                      getImageFocalPoint(angledSlide.media, 'mobile')
                    "
                  >
                    <div class="hero__angled-media-shell">
                      <img
                        [ngSrc]="angledSlide.media.imageUrl"
                        [alt]="angledSlide.media.alt"
                        [width]="angledSlide.media.width"
                        [height]="angledSlide.media.height"
                        [priority]="shouldPrioritizeSlide(slideIndex)"
                        [attr.loading]="shouldPrioritizeSlide(slideIndex) ? 'eager' : 'lazy'"
                        class="hero__angled-media-image"
                      />
                    </div>

                    <div class="hero__angled-content-shell">
                      <div class="hero__content hero__content--angled">
                        @if (angledSlide.eyebrow) {
                          <p class="hero__eyebrow">{{ angledSlide.eyebrow }}</p>
                        }

                        <h2 class="hero__headline">{{ angledSlide.headline }}</h2>
                        <p class="hero__subheadline">{{ angledSlide.subheadline }}</p>

                        <div class="hero__actions">
                          <a
                            class="hero__action hero__action--primary"
                            [href]="actionHref(angledSlide.primaryAction.route, angledSlide.primaryAction.queryParams)"
                            (click)="onActionClick($event, angledSlide.primaryAction.route, angledSlide.primaryAction.queryParams)"
                          >
                            {{ angledSlide.primaryAction.label }}
                          </a>

                          @if (angledSlide.secondaryAction; as secondaryAction) {
                            <a
                              class="hero__action hero__action--secondary"
                              [href]="actionHref(secondaryAction.route, secondaryAction.queryParams)"
                              (click)="onActionClick($event, secondaryAction.route, secondaryAction.queryParams)"
                            >
                              {{ secondaryAction.label }}
                            </a>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                }
              }

              @case ('background') {
                <div class="hero__background hero__background--bleed">
                  <img
                    [ngSrc]="getBackgroundSlide(slide).backgroundImage.imageUrl"
                    [alt]="getBackgroundSlide(slide).backgroundImage.alt"
                    [width]="getBackgroundSlide(slide).backgroundImage.width"
                    [height]="getBackgroundSlide(slide).backgroundImage.height"
                    [priority]="shouldPrioritizeSlide(slideIndex)"
                    [attr.loading]="shouldPrioritizeSlide(slideIndex) ? 'eager' : 'lazy'"
                    class="hero__background-image"
                  />
                  <div
                    class="hero__background-overlay"
                    [class.hero__background-overlay--light]="getBackgroundSlide(slide).overlayStrength === 'light'"
                    [class.hero__background-overlay--medium]="getBackgroundSlide(slide).overlayStrength === 'medium'"
                    [class.hero__background-overlay--strong]="getBackgroundSlide(slide).overlayStrength === 'strong'"
                  ></div>

                  <div
                    class="hero__background-shell"
                    [class.hero__background-shell--center]="getBackgroundSlide(slide).contentAlign === 'center'"
                  >
                    <div
                      class="hero__content hero__content--background"
                      [class.hero__content--center]="getBackgroundSlide(slide).contentAlign === 'center'"
                    >
                      @if (slide.eyebrow) {
                        <p class="hero__eyebrow hero__eyebrow--inverse">{{ slide.eyebrow }}</p>
                      }

                      <h2 class="hero__headline hero__headline--inverse hero__headline--background">
                        {{ slide.headline }}
                      </h2>
                      <p class="hero__subheadline hero__subheadline--inverse hero__subheadline--background">
                        {{ slide.subheadline }}
                      </p>

                      <div class="hero__actions hero__actions--background hero__actions--center">
                        <a
                          class="hero__action hero__action--primary"
                          [href]="actionHref(slide.primaryAction.route, slide.primaryAction.queryParams)"
                          (click)="onActionClick($event, slide.primaryAction.route, slide.primaryAction.queryParams)"
                        >
                          {{ slide.primaryAction.label }}
                        </a>

                        @if (slide.secondaryAction; as secondaryAction) {
                          <a
                            class="hero__action hero__action--ghost"
                            [href]="actionHref(secondaryAction.route, secondaryAction.queryParams)"
                            (click)="onActionClick($event, secondaryAction.route, secondaryAction.queryParams)"
                          >
                            {{ secondaryAction.label }}
                          </a>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              }
            }
          </article>
        }

        @if (slideCount() > 1) {
          <div class="hero__controls">
            <div class="hero__indicators" role="tablist" aria-label="Seleccion de heroes">
              @for (slide of slides(); track trackSlide($index, slide)) {
                <button
                  class="hero__indicator"
                  type="button"
                  role="tab"
                  [class.hero__indicator--active]="isSlideActive($index)"
                  [attr.aria-current]="isSlideActive($index) ? 'true' : null"
                  [attr.aria-selected]="isSlideActive($index)"
                  [attr.aria-label]="'Mostrar hero ' + formatCounter($index + 1) + ' de ' + formatCounter(slideCount()) + ': ' + slide.headline"
                  (click)="goTo($index)"
                >
                  <span class="hero__indicator-dot"></span>
                  @if (isSlideActive($index) && indicatorsAnimated()) {
                    <span
                      class="hero__indicator-progress"
                      [style.animation-duration.ms]="autoplayMs()"
                    ></span>
                  }
                </button>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
</section>
}
